module.exports = __webpack_public_path__ + "img/sveabusiness@2x.4af214f.png";